import type { InputHTMLAttributes, ReactNode } from "react";

import { cn } from "../lib/cn.js";

/**
 * A single-line text input. Ported from the `.field` class this package replaced.
 *
 * `bg-input/30` rather than an opaque fill: these render over a live gradient, and a solid
 * background would cut a visible rectangle out of it. See tokens.css on the translucent neutrals.
 */

const FIELD = [
  "flex h-9 w-full min-w-0 rounded-control border border-input bg-input/30 px-3 py-1",
  "text-ink placeholder:text-muted transition-[color,box-shadow] outline-none",
  "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
  "disabled:cursor-not-allowed disabled:opacity-50",
].join(" ");

export type TextFieldProps = InputHTMLAttributes<HTMLInputElement>;

export function TextField({ className, type = "text", ...rest }: TextFieldProps): ReactNode {
  return <input type={type} className={cn(FIELD, className)} {...rest} />;
}

/** Exported so `MoneyInput` and any future control can share the exact field appearance. */
export const fieldClassName = FIELD;
